import { render, staticRenderFns } from "./NzSdk.vue?vue&type=template&id=6fbb71ac&scoped=true"
import script from "./NzSdk.vue?vue&type=script&lang=js"
export * from "./NzSdk.vue?vue&type=script&lang=js"
import style0 from "./NzSdk.vue?vue&type=style&index=0&id=6fbb71ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbb71ac",
  null
  
)

export default component.exports